import Api from "./Api";
import { API_VERSION } from "@/config/index";

export default {
  GetAllOffers(payload) {
    return Api().get(`${API_VERSION}/webapp/alloffers`);
  },
  GetHomepageOffers(payload) {
    return Api().get(`${API_VERSION}/webapp/homepageoffers`);
  },
  VerifyPromo(payload) {
    return Api().post(`${API_VERSION}/webapp/promos/verify`, payload);
  },
  GetPromosAndOffers(payload) {
    let query = "";
    if (payload.food) {
      query += `?food=${payload.food}`;
    }
    return Api().get(`${API_VERSION}/webapp/promos${query}`);
  },
  CheckPromo(payload) {
    return Api().post(
      `${API_VERSION}/webapp/promos/check`,
      payload,
    )
  },
  RemovePromo(payload){
    return Api().post(
      `${API_VERSION}/webapp/promos/remove`,
      payload,
    )
  }
};



// WEBPACK FOOTER //
// ./src/apiServices/PromosandOffersService.js